"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeSpanIO = normalizeSpanIO;
const json_1 = require("./core/utils/json");
const collect_1 = require("./core/accumulator/collect");
const interface_1 = require("./core/accumulator/interface");
const parser_context_1 = require("./core/parser-context");
function parseIOValue(value) {
    const parsed = (0, json_1.parseIfString)(value);
    return { value: parsed, record: (0, json_1.asRecord)(parsed) };
}
function parseSpanIO(span) {
    return {
        input: parseIOValue(span.input),
        output: parseIOValue(span.output),
        metadata: parseIOValue(span.metadata),
    };
}
/**
 * Normalize an already-adapted span I/O value.
 *
 * This is the client-safe parser entry point. Source-specific adapters such as
 * ClickHouse event rows and OTel spans stay in the server-only wrapper.
 */
function normalizeSpanIO(span) {
    const { input, output, metadata } = parseSpanIO(span);
    const accumulator = (0, interface_1.createAccumulator)();
    (0, collect_1.collectIO)(input, (0, parser_context_1.createParserContext)("input"), accumulator);
    (0, collect_1.collectIO)(output, (0, parser_context_1.createParserContext)("output"), accumulator);
    (0, collect_1.collectMetadata)(metadata, accumulator);
    const additionalInput = accumulator.unparsedKeys.input;
    const hasAdditionalInput = additionalInput !== undefined && Object.keys(additionalInput).length > 0;
    return {
        messages: accumulator.messages,
        toolDefinitions: accumulator.toolDefinitions,
        span,
        ...(hasAdditionalInput ? { additionalInput } : {}),
    };
}
